import { useEffect, useState } from 'react';
import axios from 'axios';
import { FaMapMarkerAlt, FaWalking } from 'react-icons/fa';

const UserTrackingPage = () => {
  const [userId, setUserId] = useState(localStorage.getItem('trackingUserId') || '');
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Generate user ID if not exists
    if (!userId) {
      const newUserId = `user_${Math.random().toString(36).substring(2, 8)}`;
      setUserId(newUserId);
      localStorage.setItem('trackingUserId', newUserId);
    }

    const trackLocation = () => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
          
          try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/locations`, {
              userId,
              latitude, 
              longitude
            });
            setError(null);
          } catch (err) {
            setError('Failed to update location. Please check your connection.');
          }
        },
        (err) => {
          setError('Please enable location services to continue.');
          console.error('Geolocation error:', err);
        },
        { 
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    };

    trackLocation();
    const interval = setInterval(trackLocation, 10000); // Update every 10 seconds
    
    return () => clearInterval(interval);
  }, [userId]);

  return (
    <div className="user-tracking-page">
      <div className="tracking-container">
        <h1><FaWalking /> Location Tracking</h1>
        
        {error && <div className="error-message">{error}</div>}
        
        {location ? (
          <>
            <div className="location-info">
              <div className="info-card">
                <h3><FaMapMarkerAlt /> Your Location</h3>
                <p>Latitude: {location.latitude.toFixed(6)}</p>
                <p>Longitude: {location.longitude.toFixed(6)}</p>
              </div>
              
              <div className="info-card">
                <h3>Your ID</h3>
                <p className="user-id">{userId}</p>
                <p className="help-text">Share this ID with admin if needed</p>
              </div>
            </div>
            
            <div className="status-message">
              <p>Your location is being updated every 10 seconds.</p>
            </div>
          </>
        ) : (
          <div className="loading-message">
            <p>Acquiring your location...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserTrackingPage;